import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {AuthProvider} from "./context/AuthProvider";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <AuthProvider>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Routes>
                        <Route path="/*" element={<App/>}/>
                    </Routes>
                </LocalizationProvider>
            </AuthProvider>
        </BrowserRouter>
    </React.StrictMode>,
);

